import { OnChanges, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { SolicitacaoDevolucaoHonra } from 'src/app/model/devolucao-honra.model';
import moment from "moment";

@Component({
    selector: 'app-devolucao-honra-listagem',
    templateUrl: './devolucao-honra-listagem.component.html',
    styleUrls: ['./devolucao-honra-listagem.component.scss'],
    standalone: false
})
export class DevolucaoHonraListagemComponent  {

  public atributosOrdenacao: EntityOrderedRequestParameters;
  private dataHoraResultado: String;
  public opcoesPaginacao : number[];

  @Input() public agentesFinanceiros: AgenteFinanceiro[] = [];
  @Input() public solicitacoesDevolucaoHonra: SolicitacaoDevolucaoHonra[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public aoExportar: EventEmitter<any> = new EventEmitter<any>();
  
  constructor() {  
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
    this.opcoesPaginacao = [10, 15, 20];
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.solicitacoesDevolucaoHonra = this.solicitacoesDevolucaoHonra.sort((a, b) => {
      if (ord.sentido === 'asc') {
        return this.compara(a, b, ord.atributo);
      } else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
      return 0;
    } else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      } else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    const _index = prop.indexOf('.');
    if (_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public nomeAgente(cnpj: string) {
    const agentes = this.agentesFinanceiros.filter(item => item.cnpj === cnpj);
    return agentes.length > 0 ? agentes[0].nome : `agente cnpj ${cnpj} desconhecido.`;
  }

  public exportarDevolucao(): void {
    this.aoExportar.emit();
  }
}
